var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedHeartButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HeartButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FF5200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill",
    fill: "#FF5200",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999998,24.5993291 C13.9098794,24.5993291 6.00038092,19.5598812 6.00038092,12.7537007 C5.96446137,9.61758175 8.4733903,7.04393963 11.6094071,7 C13.3311478,7.00718505 14.9524784,7.81140305 15.9999998,9.17783698 C17.0475601,7.81134278 18.6689799,7.00711715 20.3907924,7 C23.5267401,7.04402692 26.0355609,9.61764988 25.9996186,12.7537007 C25.9996186,19.5598812 18.0902801,24.5993291 15.9999998,24.5993291 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeartButton);
export default __webpack_public_path__ + "static/media/RedHeartButton.7eabee518eef1a691000b94f6b203f53.svg";
export { ForwardRef as ReactComponent };